import React, { Fragment } from 'react';
import InterSitial from '../intersitial';
import Icon from '../icon';
import useMenu from '../../../../hooks/useMenu';
export interface SocialNetworkItems {
	name: string;
	link: string;
}
export interface SocialNetwork {
	position?: string;
}

const SocialNetworks: React.FC<SocialNetwork> = ({ position }) => {
	const { socialNetworks: items } = useMenu();
	const NetworkIcon = ({ name }: SocialNetworkItems) => {
		switch (name) {
			case 'youtube':
				return (
					<Icon
						viewBox=" 0 0 35 24"
						type={name}
						className="w-9 text-icon hover:text-icon-hover"
						title={name}
					/>
				);

			default:
				return (
					<Icon
						viewBox=" 0 0 28 28"
						type={name}
						className="w-7 text-icon hover:text-icon-hover"
						title={name}
					/>
				);
		}
	};

	return (
		<>
			<div className="flex items-center gap-3.5 flex-wrap">
				{items.map((network: SocialNetworkItems) => (
					<Fragment key={`${network.name}-icon`}>
						<InterSitial
							link={network.link}
							eventLabel={network?.name ? `${network.name} icon` : ''}
							rel="noopener noreferrer"
							target="_blank"
							position={position}>
							<span className="sr-only">{network.name}</span>
							<NetworkIcon name={network.name} link={network.link} />
						</InterSitial>
					</Fragment>
				))}
			</div>
		</>
	);
};

export default SocialNetworks;
